(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('InvoicesOverviewController', InvoicesOverviewController);

    InvoicesOverviewController.$inject = ['$state', '$stateParams', '$sce', '$uibModal', 'InvoicesService', 'ExpoService', 'AdmService'];

    function InvoicesOverviewController($state, $stateParams, $sce, $uibModal, InvoicesService, ExpoService, AdmService) {
        var vm = this;


        vm.dueDate = {startDate: null, endDate: null};
        vm.dispatchDate = {startDate: null, endDate: null};
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };
        vm.getExpoCities         = getExpoCities;
        vm.getInvoiceStatusLabel = getInvoiceStatusLabel;
        vm.getInvoiceStatusClass = getInvoiceStatusClass;
        vm.remove                = remove;
        vm.sendToCustomer        = sendToCustomer;
        vm.sendToSeller          = sendToSeller;
        vm.invoiceStatus         = [{id : -1, name : '--- All ---'}, {id : 1, name : 'Paid'}, {id : 0, name : 'Not paid'}];
        vm.invoiceStatusSelected = {id : -1, name : '--- All ---'};
        vm.invoiceTypesSelected  = [];
        vm.control_id            = '';
        vm.tab                   = 1;
        vm.changeTab             = changeTab;

        vm.sellers              = [];
        vm.sellerSelected       = [];
        vm.loadSellers          = loadSellers;

        vm.expos                = [];
        vm.expoSelected         = [];
        vm.exposCitiesSelected  = [];
        vm.loadExpos            = loadExpos;

        vm.virtualFairs         = [];
        vm.virtualFairSelected  = [];
        vm.loadVirtualFairs     = loadVirtualFairs;


        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        vm.getByFilter    = getByFilter;

        activate();

        function activate() {
            loadSellers();
            loadExpos();
            loadVirtualFairs();
            getInvoiceTypes();
        }

        function loadExpos() {
            ExpoService.getExposForSelect().then(function(response) {
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function getInvoiceTypes() {
            InvoicesService.getInvoiceTypes().then(function(response) {
                vm.invoiceTypes = response.data;
            }).catch(function(err) {
            });
        }

        function loadVirtualFairs() {
            ExpoService.getExposVirtualFair().then(function(response){
                vm.virtualFairs = response.data;
            }).catch(function(err) {
            });
        }

        function loadSellers() {
            AdmService.getSellers().then(function(response) {
                vm.sellers = response.data;
            }).catch(function(err) {
            });
        }

        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };

        function getInvoiceStatusLabel(status, due_date) {
            if (status === 'paid')
                return 'Paid';
            else {
                var now = new Date();
                due_date = new Date(due_date);

                if (now > due_date)
                    return 'Overdue';
            }

            return 'Waiting Payment';

        }


        function getInvoiceStatusClass(status, due_date) {
            if (status === 'paid')
                return 'label-success';
            else {
                var now = new Date();
                due_date = new Date(due_date);

                if (now > due_date)
                    return 'label-danger';
            }

            return 'label-warning';
        }

        function remove(invoice) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this invoice?')
                .set('onok', function (){
                    InvoicesService.destroy(invoice.id).then(function() {
                        vm.invoices.splice(vm.invoices.indexOf(invoice), 1);
                        alertify.notify('Invoice removed', 'success', 3);
                    });
                })
                .show();
        }

        function sendToCustomer(invoice) {
            alertify
                .confirm('Do you really want to send this invoice to ' + invoice.contact_email + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    InvoicesService.sendInvoiceToCustomer(invoice.id).then(function() {
                        alertify.notify('Invoice sent!', 'success', 3);
                    });
                })
                .show();
        }

        function sendToSeller(invoice) {
            alertify
                .confirm('Do you really want to send this invoice to ' + invoice.seller_email + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    InvoicesService.sendInvoiceToSeller(invoice.id).then(function() {
                        alertify.notify('Invoice sent!', 'success', 3);
                    });
                })
                .show();
        }


        function getByFilter() {
            vm.flag = false;
            vm.query = {};

            vm.query['page'] = vm.page;

            if (vm.control_id) {
                vm.query['control_id'] = vm.control_id;
            }
            if (vm.dueDate.startDate && vm.dueDate.endDate) {
                vm.query['due_date_start']  = moment(vm.dueDate.startDate).format('YYYY-MM-DD 00:00:00');
                vm.query['due_date_end']    = moment(vm.dueDate.endDate).format('YYYY-MM-DD 23:59:59');
            }
            if (vm.dispatchDate.startDate && vm.dispatchDate.endDate) {
                vm.query['dispatch_date_start']  = moment(vm.dispatchDate.startDate).format('YYYY-MM-DD 00:00:00');
                vm.query['dispatch_date_end']    = moment(vm.dispatchDate.endDate).format('YYYY-MM-DD 23:59:59');
            }
            if (vm.sellerSelected) {
                vm.query['seller_id'] = vm.sellerSelected.id;
            }
            if (vm.expoSelected) {
                vm.query['expo_id'] = [];
                angular.forEach(vm.expoSelected, function(value, key) {
                    vm.query['expo_id'].push(value.id);
                });
                vm.query['expo_id'] = vm.query['expo_id'].join();
            }
            if (vm.exposCitiesSelected) {
                vm.query['expo_locations'] = [];
                angular.forEach(vm.exposCitiesSelected, function(value, key) {
                    vm.query['expo_locations'].push(value.id);
                });
                vm.query['expo_locations'] = vm.query['expo_locations'].join();
            }
            if (vm.virtualFairSelected) {
                vm.query['virtual_fair_id'] = [];
                angular.forEach(vm.virtualFairSelected, function(value, key) {
                    vm.query['virtual_fair_id'].push(value.id);
                });
                vm.query['virtual_fair_id'] = vm.query['virtual_fair_id'].join();
            }
            if (vm.sellerSelected) {
                vm.query['seller_id'] = [];
                angular.forEach(vm.sellerSelected, function(value, key) {
                    vm.query['seller_id'].push(value.id);
                });
                vm.query['seller_id'] = vm.query['seller_id'].join();
            }
            if (vm.invoiceStatusSelected.id > -1)
            {
                vm.query['status'] = vm.invoiceStatusSelected.id;
            }
            if (vm.invoiceTypesSelected)
            {
                vm.query['type'] = [];
                angular.forEach(vm.invoiceTypesSelected, function(value, key) {
                    vm.query['type'].push(value.type);
                });
                vm.query['type'] = vm.query['type'].join();
            }
            InvoicesService.getInvoicesForOverview(vm.query).then(function(response) {
                vm.flag = true;
                vm.result = response.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }

        function getExpoCities()
        {
            vm.query = {};
            vm.query['expos_ids'] = [];
            angular.forEach(vm.expoSelected, function(value, key) {
                vm.query['expos_ids'].push(value.id);
            });
            vm.query['expos_ids'] = vm.query['expos_ids'].join();
            ExpoService.getExposCities(vm.query).then(function(response) {
                vm.exposCities = response.data;
            }).catch(function(err) {

            });
        }

        function changeTab(tab) {
            vm.tab = tab;
        }

        function openSubcategoryModal(category) {
            
        }
    }

})();